import React, { Suspense, lazy } from 'react';
import { TopBar } from './components/TopBar';
import { CountdownBar } from './components/CountdownBar';
import { HeroSection } from './components/HeroSection';
const VideoProofSection = lazy(() => import('./components/VideoProofSection').then(module => ({
  default: module.VideoProofSection
})));
const BenefitsSection = lazy(() => import('./components/BenefitsSection').then(module => ({
  default: module.BenefitsSection
})));
const QualityVideoSection = lazy(() => import('./components/QualityVideoSection').then(module => ({
  default: module.QualityVideoSection
})));
const WinxBonusSection = lazy(() => import('./components/WinxBonusSection').then(module => ({
  default: module.WinxBonusSection
})));
const PricingSection = lazy(() => import('./components/PricingSection').then(module => ({
  default: module.PricingSection
})));
const TestimonialsSection = lazy(() => import('./components/TestimonialsSection').then(module => ({
  default: module.TestimonialsSection
})));
const FAQSection = lazy(() => import('./components/FAQSection').then(module => ({
  default: module.FAQSection
})));
export function App() {
  return <div className="min-h-screen bg-[#FFFAF7] font-sans" data-id="element-0" data-mp="3mjpyp5m02aqb">
      <TopBar data-id="element-1" data-mp="3rbzpsoyupgu6" />
      <CountdownBar data-id="element-2" data-mp="3rdkh85pvcjnt" />
      <main data-id="element-3" data-mp="3rd17vdeab3le">
        <HeroSection data-id="element-4" data-mp="3relvej26lm9r" />
        <Suspense fallback={<div className="h-32" data-id="element-6" data-mp="682dxcgkib2" />} data-id="element-5" data-mp="5opiv1o0k3w">
          <VideoProofSection data-id="element-7" data-mp="56m9egl55mh" />
          <BenefitsSection data-id="element-8" data-mp="2zl3cjn8vpa6d" />
          <QualityVideoSection data-id="element-9" data-mp="2zlv8iz6e19x6" />
          <WinxBonusSection data-id="element-10" data-mp="2zmwi0z7r9ocs" />
          <PricingSection data-id="element-11" data-mp="33mov9p83gioh" />
          <TestimonialsSection data-id="element-12" data-mp="33lwy49yumcw3" />
          <FAQSection data-id="element-13" data-mp="33n6xr3lcnt4u" />
        </Suspense>
      </main>
      <footer className="bg-[#2D2D3F] text-white py-6 text-center text-sm opacity-90" data-id="element-14" data-mp="38l8hzruihyhw">
        <p data-id="element-15" data-mp="3dkurprb4swly">
          © {new Date().getFullYear()} Mega Pack Disney. Todos los derechos
          reservados.
        </p>
      </footer>
    </div>;
}